import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import BrandingSettings from "./BrandingSettings";

const BrandingPage = ({ buttonColor }) => {
  const { userId } = useParams();
  return <BrandingSettings userId={userId} buttonColor={buttonColor} />;
};

// Wrap with layout
const BrandingPageWithLayout = () => (
  <WayfinderLayout>
    <BrandingPage />
  </WayfinderLayout>
);

export default BrandingPageWithLayout;
